import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  CONSTANT,
  LoaderService,
  ObservableService,
  OrderService,
} from '@bst-frontend/shared';
import { RightPanelComponent } from './right-panel/right-panel.component';

@Component({
  selector: 'bst-frontend-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.css'],
})
export class OrderDetailComponent implements OnInit, AfterViewInit {
  id = '';
  orderData: any;
  isPickupLocation = false;
  @ViewChild('rightPanel') rightPanel!: RightPanelComponent;

  constructor(
    private activeRoute: ActivatedRoute,
    private orderService: OrderService,
    private loader: LoaderService,
    private observableService: ObservableService
  ) {}

  ngOnInit(): void {
    this.id = this.activeRoute.snapshot.paramMap.get('id') || '';
    this.getOrderDetails();
    this.observableService.data$.subscribe((data) => {
      if (data && data.refresh) {
        this.getOrderDetails();
      }
    });
  }

  onOpenPickupFromLeft() {
    // call the method directly on the right panel
    if (
      this.rightPanel &&
      typeof this.rightPanel.openPickupModal === 'function'
    ) {
      this.rightPanel.openPickupModal();
    } else {
      console.warn(
        'Right panel not ready or does not expose openPickupModal()'
      );
    }
  }

  getOrderDetails() {
    this.loader.show();
    this.orderData = undefined;
    this.orderService.getOrderDetail(this.id).subscribe({
      next: (resp) => {
        this.orderData = resp.data;
      },
      error: (err) => {
        console.error('Failed to fetch order', err);
      },
      complete: () => {
        this.loader.hide();
      },
    });
  }

  ngAfterViewInit(): void {
    console.log('Ng Afterview Init', this.id);
  }
}
